<template>
  <div>
    <div ref="flyaway"> <!-- so named because it will fly away to another component -->
      <slot>
      </slot>
    </div>
  </div>
</template>
<script>
import RichMarker from 'googlemaps-rich-marker-web';

export default {
  props: {
    position: {}
  },
  data () {
    return {
      marker: {
        id: null,
        name: null
      }
    };
  },
  computed: {
    google () {
      return window.google;
    }
  },
  methods: {
    createMarker () {
      this.$parent.$parent.$mapPromise.then((map) => {
        this.marker = new RichMarker.RichMarker({
          position: new this.google.maps.LatLng(this.position.lat, this.position.lng),
          map,
          draggable: false,
          flat: true,
          anchor: RichMarker.RichMarkerPosition.MIDDLE,
          content: this.$refs.flyaway,
          id: this.marker.id,
          title: this.marker.name
        });
      });
    }
  },
  watch: {
    position () {
      this.createMarker();
    }
  },
  mounted () {
    this.createMarker();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RichMarker.vue